(function(){
    $('.indexcollectionSwiper').on('click', '.copy_code_btn', function() {
        let codeText = $(this).closest('.swiper-slide').find('.dis_code').html();
        console.log(codeText);
        copy(false, codeText, $(this));
    })
    $('.mindexcollectionSwiper').on('click', '.copy_code_btn', function() {
        let codeText = $(this).closest('.swiper-slide').find('.dis_code').html();
        console.log(codeText);
        copy(false, codeText, $(this));
    })

    function copy (id, attr,that) {
        let target = null;
    
        if (attr) {
            target = document.createElement('div');
            target.id = 'tempTarget';
            target.style.opacity = '0';
            if (id) {
                let curNode = document.querySelector('#' + id);
                target.innerText = curNode[attr];
            } else {
                target.innerText = attr;
            }
            document.body.appendChild(target);
        } else {
            target = document.querySelector('#' + id);
        }
    
        try {
            let range = document.createRange();
            range.selectNode(target);
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);
            document.execCommand('copy');
            window.getSelection().removeAllRanges();
            that.html('COPIED')
            setTimeout(function() {
                that.html('Get code')
            }, 1500)
        } catch (e) {
            console.log('复制失败')
        }
    
        if (attr) {
            // remove temp target
            target.parentElement.removeChild(target);
        }
    }
  
})()